// extracted by mini-css-extract-plugin
export default {"tooltip":"style_tooltip__dvi93","dates":"style_dates__pZDqK"};